define.alias("ember-cli-string-helpers/helpers/html-safe", "calendar/helpers/html-safe");